import { abtastyService } from "@/services";

const MyRTICPersonalize = ({ href }) => {
  return (
    <a
      onClick={(e) => {
        e.stopPropagation();

        abtastyService.trackClick('Product Card: MyRTIC Click');
      }}
      href={href}
      className='tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-text-base tw-font-normal tw-text-[#242424] tw-transition hover:tw-text-brand-black hover:!tw-no-underline'>
      <span>Personalize it with</span>
      <img src='/assets/images/rtic/myRTIC-Logo.png' alt='MyRTIC Logo' className='tw-h-[20px]' />
    </a>
  );
};

export default MyRTICPersonalize;
